import React from 'react';

import i18n from 'i18n-js';
import styles from '../styles';

interface TotalAmountProps {
    amount: number | string | React.ReactNode;
    currency: string;
    style?: React.CSSProperties; 
}

export default function TotalAmount(props: TotalAmountProps) {
    const classes = styles();

    return (
        <div
            className={`${classes.tabPriceContainer} ${classes.tabPriceAlignRight10}`}
            style={props.style}
        >
            <h4>{i18n.t('common.total')}: </h4>
            <div>
                <span className={classes.currencyText}>{props.currency}</span>
                <span className={classes.currencyAmount}>{props.amount}</span>
            </div>
        </div>
    );
}
